"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentLabel = getComponentLabel;
const property_1 = require("@genesys/property");
const text_definitions_1 = require("./text-definitions");
function getComponentLabel(translate, productId, properties) {
    const label = property_1.PropertyValueSet.getText("label", properties);
    if (label !== undefined) {
        return translate((0, text_definitions_1.curlyTranslate)(label, productId.substring(0, 3)));
    }
    return translate((0, text_definitions_1.product)(productId));
}
//# sourceMappingURL=utils.js.map